export default function (value) {
  return value ? parseFloat(value.replace(/[^0-9.]+/, '')) || 0 : 0;
}
